import { createSlice } from "@reduxjs/toolkit";
import { DashboardDataPieces } from "../../interfaces/interfaces";

const INITIAL_STATE: DashboardDataPieces = {
  pinnedCharts: [],
  charts: [],
  pinnedPivotTables: [],
  pivotTables: [],
  pinnedCards: [],
  pinnedCohorts: [],
};

const dashboardDatapieces = createSlice({
  name: "dashboardDatapieces",
  initialState: INITIAL_STATE,
  reducers: {
    update: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export const { update } = dashboardDatapieces.actions;
export const DashboardDatapieces = dashboardDatapieces.reducer;
